<template>
  <footer
    v-if="!whitelabel"
    class="w-full pb-6"
  >
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap items-center justify-center xl:justify-between">
        <div class="w-full px-4 xl:w-4/12">
          <div class="py-1 text-center text-sm font-semibold xl:text-left">
            © {{ date }} Rack Manage. All rights reserved.
          </div>
        </div>
        <div class="w-full px-4 xl:w-8/12">
          <ul class="m-0 flex list-none flex-wrap justify-center xl:justify-end">
            <li>
              <a
                href="https://support.rackmanage.io/"
                class="block px-3 py-1 text-sm font-semibold hover:text-slate-700"
              >
                Help
              </a>
            </li>
            <li>
              <a
                href="https://rackmanage.featurebase.app/?createPost=true"
                class="block px-3 py-1 text-sm font-semibold hover:text-slate-700"
              >
                Feedback
              </a>
            </li>
            <li v-show="feedbackLoaded">
              <button
                id="report-bug-button"
                class="block bg-transparent px-3 py-1 text-sm font-semibold text-slate-800 hover:text-slate-700"
              >
                Report Bug
              </button>
            </li>
            <a-dropdown
              :trigger="['click']"
              placement="topLeft"
              @visible-change="isActive = $event"
            >
              <li>
                <a
                  class="block px-3 py-1 text-sm font-semibold hover:text-slate-700"
                  href="#"
                  @click.prevent
                >
                  Legal
                  <i
                    class="fa-solid fa-caret-right ml-1 transition-transform duration-200"
                    :class="{ '-rotate-90': isActive }"
                  />
                </a>
              </li>
              <template #overlay>
                <a-menu>
                  <a-menu-item>
                    <a href="/privacy">Privacy Policy</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="/terms">Terms of Service</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="/subprocessors">Sub-Processors</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="/cookies">Cookie Policy</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a
                      onclick="javascript:CookieScript.instance.show()"
                      href="javascript:void(0)"
                    >
                      Cookie Preferences
                    </a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useStore } from '../../api/index.ts';
import { getClient } from '@sentry/browser';
import { onMounted, ref } from 'vue';

const store = useStore();
const date = new Date().getFullYear();
const feedbackLoaded = ref(false);
const isActive = ref(false);

const whitelabel = ref(
  store.checkedDomain != null
  && store.checkedDomain.data
  && !store.checkedDomain.domain.endsWith(import.meta.env.VITE_HOSTNAME),
);

onMounted(() => {
  try {
    const client = getClient();
    const feedback = client?.getIntegrationByName('Feedback');
    if (feedback && document.querySelector('#report-bug-button')) {
      // @ts-expect-error - Feedback integration has attachTo method
      feedback.attachTo(document.querySelector('#report-bug-button'));
      feedbackLoaded.value = true;
    }
  } catch (error) {
    console.warn('Error attaching feedback to report bug button:', error);
  }
});
</script>
